import { Trans } from "@lingui/macro";
import { UiBox } from "@smp/ui";
import { REACT_APP__BASE_PATH } from "@smp/utils";
import { useMemo, useState } from "react";
import { Helmet } from "react-helmet";

import { useContextPolotnoTemplates } from "@/components/features/polotno_templates/context";
import { Screen } from "@/components/layout/screen";
import { getLocationOrigin } from "@/utils";

import {
  Content,
  EmbedButton,
  RandomButton,
  SearchBar,
  SelectedTags,
  SortDropdown,
} from "./components";
import classes from "./viewpoer.module.css";

export const Viewport = () => {
  const {
    state: { isWidget, activeTemplateId, activeUnsplashEntry },
  } = useContextPolotnoTemplates();
  const [hasRelevantTemplates, setHasRelevantTemplates] = useState(false);
  const origin = useMemo(getLocationOrigin, []);

  if (isWidget) {
    return (
      <Screen ContentBoxProps={{ className: classes.screenContentWidget }}>
        <Content />
      </Screen>
    );
  }

  return (
    <>
      {!activeTemplateId && !activeUnsplashEntry && (
        <Helmet>
          <meta name="robots" content="noindex" />
          <link
            rel="canonical"
            href={`${origin}${REACT_APP__BASE_PATH}/templates`}
          />
        </Helmet>
      )}

      <Screen
        title={<Trans>templates.viewport.title_Templates</Trans>}
        actionsRight={
          !import.meta.env.SSR ? (
            <div>
              <RandomButton />
              <EmbedButton disabled={!hasRelevantTemplates} />
            </div>
          ) : undefined
        }
        BoxProps={{ className: classes.screen }}
      >
        <SearchBar />
        <UiBox
          display="flex"
          alignItems="center"
          justifyContent="space-between"
          mb={2}
        >
          <SelectedTags />
          <SortDropdown />
        </UiBox>
        <Content onChangeRelevantFlag={setHasRelevantTemplates} />
      </Screen>
    </>
  );
};
